import { Blob } from '@consigli/types';
import { UniqueIdentifier } from '@dnd-kit/core';
import { useState } from 'react';

import { FolderDocumentsType } from '@/util/types';

/**
 * Custom hook to manage drag-and-drop state for folder documents.
 *
 * This hook centralizes all state related to dragging files or folders within the insight folders UI.
 * It is used to track which card (file/folder) is being dragged, which files are selected for batch operations,
 * the currently active file being dragged, the folder currently targeted for a drop, and whether a confirmation
 * popup (e.g., for destructive actions) is open.
 *
 * The hook also provides setters for each state and a resetDragState function to clear all drag-related state.
 */
export const useDragState = () => {
  const [draggingCardId, setDraggingCardId] = useState<UniqueIdentifier>('');
  const [selectedFiles, setSelectedFiles] = useState<FolderDocumentsType[]>([]);
  const [confirmationPopupIsOpen, setConfirmationPopupIsOpen] = useState(false);
  const [activeDraggedFile, setActiveDraggedFile] = useState<Blob | null>(null);
  const [selectedFolderForDrag, setSelectedFolderForDrag] = useState<UniqueIdentifier>('');

  const resetDragState = () => {
    setDraggingCardId('');
    setActiveDraggedFile(null);
    setSelectedFolderForDrag('');
    setConfirmationPopupIsOpen(false);
  };

  return {
    draggingCardId,
    setDraggingCardId,
    selectedFiles,
    setSelectedFiles,
    confirmationPopupIsOpen,
    setConfirmationPopupIsOpen,
    activeDraggedFile,
    setActiveDraggedFile,
    selectedFolderForDrag,
    setSelectedFolderForDrag,
    resetDragState,
  };
};
